import { type TableData, formatCellValue } from './extractTableData';

const MULTILINE_CELL_SEPARATOR = ' ';

const escapeCell = (value: unknown): string =>
  formatCellValue(value)
    .replace(/\\/g, '\\\\')
    .replace(/\|/g, '\\|')
    .replace(/\r\n|\r|\n/g, MULTILINE_CELL_SEPARATOR);

export const tableDataToMarkdown = ({ columns, rows }: TableData): string => {
  if (columns.length === 0) return '';

  const cells = (values: unknown[]) =>
    `| ${values.map(v => escapeCell(v)).join(' | ')} |`;

  const header = cells(columns);
  const separator = `| ${columns.map(() => '---').join(' | ')} |`;
  if (rows.length === 0) return `${header}\n${separator}`;

  const body = rows.map(row => cells(columns.map(col => row[col]))).join('\n');
  return `${header}\n${separator}\n${body}`;
};
